/**
 * The user theme preference for the app.
 */
export enum UserTheme {
    Light = 'light',
    Dark = 'dark',
    Default = 'default',
}
